import {Injectable} from '@angular/core';
import {HttpService} from '../core/services/http.service';
import {HttpServiceBase} from '../core/services/HttpServiceBase';
import {Holo, Language} from '../core/entities/entities';
import {ServiceName} from '../core/services/Service';
import {ProductStructureService} from './product-structure.service';

@Injectable()
export class HoloService extends HttpServiceBase<Holo> {

  getCleanInstance(): Holo {
    return new Holo();
  }

  public hasSingleGet() {
    return false;
  }

  public refreshOnRouteChange() {
    return false;
  }

  constructor(protected http: HttpService) {
    super(http);
  }

  getUrl() {
    return  'holo';
  }

  public fromJson(json): Holo {
    const me = this;
    const item: Holo = Object.assign(this.getCleanInstance(), json);

    if(json.name) {
      item.name = json.name || item.name;
      item.code = json.code || '' + item.id;
    }




    return item;
  }

}

ServiceName.add('HoloService', HoloService);




// WEBPACK FOOTER //
// ./src/app/services/holo.service.ts